import { updateItems } from '@/mocks/home';

const tagStyles: Record<string, string> = {
  '专题': 'bg-primary-100 text-primary-700',
  '技术': 'bg-accent-100 text-accent-700',
  '更新': 'bg-secondary-100 text-secondary-700',
  '产品': 'bg-primary-100 text-primary-700',
  '内容': 'bg-secondary-100 text-secondary-700',
  '社区': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[800px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            蚂蚁影视的平台更新、内容上线与社区动态一览
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-0">
            {updateItems.map((item) => (
              <div key={item.id} className="relative flex gap-4 md:gap-6 pb-8 md:pb-10 last:pb-0">
                <div className="flex-shrink-0 relative z-10">
                  <div className="w-[42px] h-[42px] md:w-[48px] md:h-[48px] rounded-full bg-background-50 border-2 border-primary-300 flex items-center justify-center">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                  </div>
                </div>

                <div className="flex-1 min-w-0 pt-1.5">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                    <span
                      className={`px-2 py-0.5 rounded text-xs font-medium ${tagStyles[item.tag] || 'bg-secondary-100 text-secondary-700'}`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}